import React, { useState, useEffect } from 'react';
import { AgGridReact, AgGridColumn } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import Select from 'react-select';
import axios from 'axios';
import { Button, Grid, Menu , Input } from 'semantic-ui-react';
import { getvendorcode,getkpidatarecon, Fetchbankinvoicedetails,getBRSConReportFromServer,Fetchexecutequery,Fetchselectivevendordetails,Fetchbankinvoicedetails_1,Fetchselectiveerpinvoicedetails,getBRSReportFromServer, Fetchbankinvoicedetails1 } from '../../../services/demo/brs/vrsreport';
import * as XLSX from 'xlsx';
import excelIcon from '../../../assets/images/excel.png';
import RenderGrid from './grid';




const VerticalTabsWithAgGrid = () => {
  const [showTabs, setShowTabs] = useState(false);
  const [showicon, setShowicon] = useState(false);
  const [inputMonth, setInputMonth] = useState(undefined);

  const [link, setLink] = useState('');
  const [erpbalance, setErpBalance] = useState(false);
  const [vendorbalance, setVendorBalance] = useState(false);
  const [annexure1diff, setannexure1Balance] = useState(false);
  const [annexure2diff, setannexure2Balance] = useState(false);
  const [annexure3diff, setannexure3Balance] = useState(false);
  const [annexure4diff, setannexure4Balance] = useState(false);
  const [annexure5diff, setannexure5Balance] = useState(false);
  const [annexure6diff, setannexure6Balance] = useState(false);
  const [annexure7diff, setannexure7Balance] = useState(false);
  const [annexure8diff, setannexure8Balance] = useState(false);
  const [annexure9diff, setannexure9Balance] = useState(false);
  const [totalcredits, settotalCredit] = useState(false);
  const [totaldebits, settotalDebit] = useState(false);
  const [totalbalan, settotalBal] = useState(false);
  const [venopenamt, setVenopen] = useState(false);
  const [intopenamt, setIntopen] = useState(false);
  const [openvarianceamt, setOpenVariance] = useState(false);
  const [totalvar, settotalVariance] = useState(false);
  const [chek, setCheck] = useState(false);
  const [recper, setReconperiod] = useState(false);  
  const [balancevariance, setVariance] = useState(false);
  const [remarkscol, setremarkscol] = useState([]);
  const [activeTab, setActiveTab] = useState('Summary');
  const [tableData, setTableData] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedOption1, setSelectedOption1] = useState('');
  const [selectedOption2, setSelectedOption2] = useState('');
  const [options, setOptions] = useState([]);
  const [division, setDivision] = useState([]);
  const tabNames = ['Summary','Annexure1', 'Annexure2','Annexure3','Annexure4','Annexure5','Annexure6','Annexure7','Annexure8','Annexure9']; 
  const [tabDataMap, setTabDataMap] = useState({});

  useEffect(() => {
    if (showTabs) {
      if (activeTab === 'Summary') {
        getKpiinfo(activeTab);
        // fetchDataForAllTabs()
      } else {
        fetchDataForTab(activeTab);
      }
    }
  }, [showTabs, activeTab]);


  const handleSearchClick = () => {
    setShowTabs(false);
    reportClick()
  };

  const handleSelection = (selectedOption) => {
    setSelectedOption(selectedOption ? selectedOption.value : '');
    setSelectedOption2(selectedOption ? selectedOption.source : '');
    // Filter divisions based on the selected vendor code
    const filteredDivisions = options.find(opt => opt.value === selectedOption.value)?.divisions || [];
    //const filteredDivisions1 = options.find(opt => opt.value === selectedOption.source)?.divisions || [];
    console.log('filteredDivisions' ,filteredDivisions )
    setSelectedOption1(filteredDivisions[0].label);
    setSelectedOption2(filteredDivisions[0].source);
    //setSelectedOption1('');
    setShowicon('False');
  };

  useEffect(() => {
    vrsvendorcode();
  }, []);

  function vrsvendorcode() {
    let payload = {};
    var getProcessingLayerList = getvendorcode();

    axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
      .then(response => {
        let data =[{ label: 'ALL', value: 'ALL',id: 'ALL',source: 'ALL' },{ label: 'AXIS 18294', value: 'axis_18294_bank_statement',id: '36101106',source: '155' },{ label: 'HDFC 062', value: 'hdfc_062_bank_statement',id:'36101101',source: '163' },{ label: 'HDFC 295', value: 'hdfc_295_bank_statement' ,id:'36101104',source: '164' },{ label: 'HDFC 828', value: 'hdfc_828_bank_statement',id:'36101102',source: '162' },{ label: 'ICICI 240', value: 'icici_240_bank_statement',id:'36101151',source: '167' },{ label: 'ICICI 2605', value: 'icici_2605_bank_statement',id:'36101111',source: '166' },{ label: 'SBI 642', value: 'sbi642_bank_statement',id:'36101105',source: '157' },{ label: 'SBI 7913', value: 'sbi7913_bank_statement',id:'36101157',source: '154' }];
         if (data) {
          let options = data.map((row) => ({
            label: row.label,
            value: row.value,
            clientId: row.id,
            divisions: data
              .filter(item => item.label === row.label)
              .map(item => ({
                label: item.id,
                value: item.id,
                key: item.label,
                source: item.source,
              })),
          }));
          setOptions(options);
          setDivision(options.length > 0 ? options[0].divisions : []);
        }
      })
      .catch(error => {
        console.error("Error in Processing Layer List!!!", error);
      });
  }

  const handleSelection1 = (selectedOption) => {
    setSelectedOption1(selectedOption ? selectedOption.value : '');
    setSelectedOption2(selectedOption ? selectedOption.source : '');
  };

  // const handleDownloadExcel = () => {
  //   if (tableData.length > 0) {
  //     const ws = XLSX.utils.json_to_sheet(tableData);
  //     const wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
  //     XLSX.writeFile(wb, "vrs_{selectoption1}.xlsx");
  //   }
  // };

  function reportClick()
  {
      
      let payload = {
          "table" : selectedOption,
          'accpacid' : selectedOption1,
          'source' : selectedOption2,
          'month' : inputMonth

      }
      let getBrsReport;
      if (selectedOption === 'ALL') {
        getBrsReport = getBRSConReportFromServer();
      } else {
        getBrsReport = getBRSReportFromServer();
      }
      axios.post(getBrsReport[1], {params : payload}, getBrsReport[0])
      .then(
          response => {
              console.log("Report Generated Response!!!", response)
              let data = response["data"];
              if (data["Status"] === "Success")
              {
                  console.log("data", data);
                  setLink(data["file"]);
                  setShowicon('True');
                  
              }
              else
                console.log("Error in File Generated!!!");
                  
              
          }
      ).catch(
          error => {
              console.log("Error in File Generated!!!", error);
          }
      );

  }

  const summaryItems = [
    { description: 'Closing Balance as per Ledger', value: erpbalance },
    { description: 'Closing Balance as per Vendor', value: vendorbalance },
    { description: 'Variance', value: balancevariance },
    { description: 'Reasons for Variance'},
    { description: 'Purchase Invoices booked by Thermax not appearing/accounted by vendor', value: annexure1diff },
    { description: 'Payment made by Thermax not accounted by vendor', value: annexure2diff },
    { description: 'TDS dedcuted by Thermax not accounted by Supplier', value: annexure3diff },
    { description: 'Debit Note raised by Thermax not accounted by Supplier', value: annexure4diff },
    { description: 'Sales considered by vendor but not accounted by Thermax', value: annexure5diff },
    { description: 'Payment received by vendor but not accounted by Thermax', value: annexure6diff },
    { description: 'Invoices reconciled with value differences', value: annexure7diff },
    { description: 'Credit Note raised by Vendor not accounted by Thermax', value: annexure8diff },
    { description: 'Contra entries as per Thermax SOA', value: annexure9diff },
    { description: 'Difference in Opening balance of Thermax & Vendor statement', value: openvarianceamt },
    { description: 'Opening balance as per Thermax', value: intopenamt },
    { description: 'Opening balance as per Vendor', value: venopenamt },
    { description: 'Sum of total variance', value: totalvar },
    { description: 'Check', value: chek },
    { description: 'Reconciliation done till', value: recper },
    // Add more summary items as needed
  ];

  

  const fetchDataForAllTabs = async () => {

    try {
      const tabs = ['Annexure1','Annexure2','Annexure3','Annexure4','Annexure5','Annexure6','Annexure9'];
      const allTabData = {};
      
  
      // Loop through each tab
      for (const tab of tabs) {
        let payload;
        let fetchFunction;
        switch (tab) {
          case 'Annexure1':
            payload = {
              query: `select sum(GL_DEBIT) as debit,sum(GL_CREDIT) as credit, sum(GL_DEBIT - GL_CREDIT) AS difference FROM Vendor_Reconcilation_System.internal_statement where SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and DOC_CATEGORY = 'STD INV' and status = 'Unmatched'`
            };

            fetchFunction = Fetchexecutequery;
            
            break;
          case 'Annexure2':
            payload = {
              
                query: `select sum(GL_DEBIT) as debit,sum(GL_CREDIT) as credit, sum(GL_DEBIT - GL_CREDIT) AS difference FROM Vendor_Reconcilation_System.internal_statement where SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and DOC_CATEGORY like '%BV%' and status = 'Unmatched'`
                       };

            fetchFunction = Fetchexecutequery;
            break;

          case 'Annexure3':
            payload = {
            
              query: `select sum(GL_DEBIT) as debit,sum(GL_CREDIT) as credit, sum(GL_DEBIT - GL_CREDIT) AS difference FROM Vendor_Reconcilation_System.internal_statement where SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and (DOC_CATEGORY ='CRM INV'OR DOC_CATEGORY LIKE '%TDS%') and status = 'Unmatched'`
            };
            fetchFunction = Fetchexecutequery;
            break;
          case 'Annexure4':
            payload = {
             
                query: `select sum(GL_DEBIT) as debit,sum(GL_CREDIT) as credit, sum(GL_DEBIT - GL_CREDIT) AS difference FROM Vendor_Reconcilation_System.internal_statement where SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and (DOC_CATEGORY LIKE '%DBM%' OR DOC_CATEGORY LIKE '%DN%') and status = 'Unmatched'`
            };
            fetchFunction = Fetchexecutequery;
            break;
          case 'Annexure5':
            payload = {
              
                query: `select sum(debit) as debit,sum(credit) as credit, sum(debit - credit) AS difference FROM Vendor_Reconcilation_System.vendor_statement where supplier_code = '${selectedOption}' and division = '${selectedOption1}'and credit = 0 and status = 'Unmatched' and vch_type not in ('Credit Note', 'Debit Note');'`
            };
            fetchFunction = Fetchexecutequery;
            break;
          case 'Annexure6':
            payload = {
              query: `select sum(debit) as debit,sum(credit) as credit, sum(debit - credit) AS difference FROM Vendor_Reconcilation_System.vendor_statement where supplier_code = '${selectedOption}' and division = '${selectedOption1}' and status = 'Unmatched' and debit=0 and vch_type not in ('Credit Note', 'Debit Note');'`
            };
            fetchFunction = Fetchexecutequery;
            break;
          
          case 'Annexure8':
              payload = {
                query: `select sum(debit) as debit,sum(credit) as credit, sum(debit - credit) AS difference FROM Vendor_Reconcilation_System.vendor_statement where supplier_code = '${selectedOption}' and division = '${selectedOption1}' and status = 'Unmatched' and vch_type in ('Credit Note', 'Debit Note');'`
              };
              fetchFunction = Fetchexecutequery;
              break;
          case 'Annexure9':
            payload = {
              query : `SELECT * FROM Vendor_Reconcilation_System.internal_statement WHERE SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and status ='Contra';`,
             
            };
            fetchFunction = Fetchexecutequery;
            break;
          default:
            payload = {};
        }
  
        // Fetch data for the current tab and store it in allTabData
        const data = await fetchDataAndSetsummaryData(tab,payload, fetchFunction);
        console.log('12345',data);

        allTabData[tab] = data;
      }
  
      // Now allTabData contains the fetched data for all tabs
      console.log('Data for all tabs:', allTabData);
      // You can then assign allTabData to the parameter you want
      // For example: setParameter(allTabData);
    } catch (error) {
      console.error('Error fetching data for all tabs:', error);
    }
  };
  


  const fetchDataForTab = async (tab) => {
    try {
      let payload;

      switch (tab) {
        case 'Annexure1':
          payload = {
            query : `SELECT GL_DATE,INVOICE_NUMBER,GL_DEBIT,GL_CREDIT FROM Vendor_Reconcilation_System.internal_statement WHERE SUPPLIER_CODE = '${selectedOption}' AND DIVISION_NAME = '${selectedOption1}'  and DOC_CATEGORY ='STD INV' and status = 'Unmatched';`,
          };

          await fetchDataAndSetTableData(payload, Fetchexecutequery);
          break;
        case 'Annexure2':
          payload = {
            query : `SELECT GL_DATE,INVOICE_NUMBER,GL_DEBIT,GL_CREDIT,INVOICE_PAYMENT_AMT FROM Vendor_Reconcilation_System.internal_statement WHERE SUPPLIER_CODE = '${selectedOption}' AND DIVISION_NAME = '${selectedOption1}' AND DOC_CATEGORY LIKE '%BV%' AND status = 'Unmatched';`,
          };
          await fetchDataAndSetTableData(payload, Fetchexecutequery);
          break;
        
        case 'Annexure3':
          payload = {
            query : `SELECT GL_DATE,INVOICE_NUMBER,GL_DEBIT,GL_CREDIT FROM Vendor_Reconcilation_System.internal_statement WHERE SUPPLIER_CODE = '${selectedOption}' AND DIVISION_NAME = '${selectedOption1}' and (DOC_CATEGORY ='CRM INV'OR DOC_CATEGORY LIKE '%TDS%') and status = 'Unmatched';`,
          };
          await fetchDataAndSetTableData(payload, Fetchexecutequery);
          break;

        case 'Annexure4':
          payload = {
          query : `SELECT GL_DATE,INVOICE_NUMBER,GL_DEBIT,GL_CREDIT FROM Vendor_Reconcilation_System.internal_statement WHERE SUPPLIER_CODE = '${selectedOption}' AND DIVISION_NAME = '${selectedOption1}' AND (DOC_CATEGORY LIKE '%DBM%' OR DOC_CATEGORY LIKE '%DN%') AND status = 'Unmatched';`, 
          };
          await fetchDataAndSetTableData(payload, Fetchexecutequery);
          break;
        
        case 'Annexure5':
          payload = {
            query : `SELECT date,\`vch_no.\`,	debit,credit FROM Vendor_Reconcilation_System.vendor_statement WHERE supplier_code = '${selectedOption}' AND division = '${selectedOption1}' and credit = 0 and status = 'Unmatched' and vch_type not in ('Credit Note', 'Debit Note');`, 

          };
          await fetchDataAndSetTableData(payload, Fetchexecutequery);
          break;

        case 'Annexure6':
          payload = {
            query : `SELECT date,\`vch_no.\`,	debit,credit FROM Vendor_Reconcilation_System.vendor_statement WHERE supplier_code = '${selectedOption}' AND division = '${selectedOption1}' and status = 'Unmatched' and debit=0 and vch_type not in ('Credit Note', 'Debit Note');`, 

          };
          await fetchDataAndSetTableData(payload, Fetchexecutequery);
          break;
        
          case 'Annexure7':
            payload = {
              query: `SELECT 
              CASE 
                  WHEN e.status = 'Match' THEN IFNULL(i.INVOICE_NUMBER, '') 
                  WHEN e.status = 'Groupmatch' THEN IFNULL(i.CHECK_ID, '') 
              END AS 'invoice_number', 
              DATE_FORMAT(i.GL_DATE, '%d-%m-%y') AS 'gl_date', 
              CASE 
                  WHEN e.status = 'Match' THEN 
                      CASE 
                          WHEN (e.credit - e.debit) >= 0 THEN CONVERT(e.credit - e.debit, DECIMAL(10, 2))
                          ELSE (CONVERT(e.debit - e.credit, DECIMAL(10, 2)) * -1)
                      END 
                  WHEN e.status = 'Groupmatch' THEN 
                      CASE 
                          WHEN (e.credit - e.debit) >= 0 THEN CONVERT(e.credit - e.debit, DECIMAL(10, 2))
                          ELSE (CONVERT(e.debit - e.credit, DECIMAL(10, 2)) * -1)
                      END 
              END AS 'ven_invoice_amount',
              CASE 
                  WHEN e.status = 'Match' THEN 
                      CASE 
                          WHEN (i.GL_DEBIT - i.GL_CREDIT) >= 0 THEN CONVERT(i.GL_DEBIT - i.GL_CREDIT, DECIMAL(10, 2))
                          ELSE (CONVERT(i.GL_CREDIT - i.GL_DEBIT, DECIMAL(10, 2)) * -1)
                      END 
                  WHEN e.status = 'Groupmatch' THEN 
                      CASE 
                          WHEN (i.GL_DEBIT - i.GL_CREDIT) >= 0 THEN CONVERT(i.GL_DEBIT - i.GL_CREDIT, DECIMAL(10, 2))
                          ELSE (CONVERT(i.GL_CREDIT - i.GL_DEBIT, DECIMAL(10, 2)) * -1)
                      END 
              END AS 'invoice_amount',
              ROUND(IFNULL(CONVERT((i.GL_DEBIT - i.GL_CREDIT)-(e.credit - e.debit), DECIMAL(10, 2)), 0.00), 2) AS 'diff_amount' 
          FROM 
              Vendor_Reconcilation_System.internal_statement i 
              INNER JOIN Vendor_Reconcilation_System.vendor_statement e ON i.match_id = e.match_id
          JOIN
              (SELECT match_id, SUM(credit) AS total_credit, SUM(debit) AS total_debit
              FROM Vendor_Reconcilation_System.vendor_statement
              WHERE supplier_code = '${selectedOption}' and division = '${selectedOption1}' AND (status = 'Match' OR status = 'Groupmatch')
              GROUP BY match_id) AS v_totals ON i.match_id = v_totals.match_id
          WHERE 
              e.supplier_code = '${selectedOption}' AND e.division = '${selectedOption1}' AND i.DIVISION_NAME = '${selectedOption1}' AND i.SUPPLIER_CODE = '${selectedOption}'
              AND (i.status = 'Match' OR i.status = 'Groupmatch')
          GROUP BY 
              invoice_number, gl_date, ven_invoice_amount, invoice_amount, e.status, i.CHECK_ID,i.GL_CREDIT, i.GL_DEBIT,e.credit,e.debit
          HAVING 
              diff_amount != '0.00';`
            };
            await fetchDataAndSetTableData(payload, Fetchexecutequery);
            break;
          
          case 'Annexure8':
              payload = {
                query : `SELECT date,\`vch_no.\`,debit,credit FROM Vendor_Reconcilation_System.vendor_statement WHERE supplier_code = '${selectedOption}' AND division = '${selectedOption1}' and status = 'Unmatched' and vch_type in ('Credit Note', 'Debit Note');`, 
              };
              await fetchDataAndSetTableData(payload, Fetchexecutequery);
              break;
        case 'Annexure9':
          payload = {
            query : `SELECT GL_DATE,INVOICE_NUMBER,	SUPPLIER_INVOICE_NO,SUPPLIER_INVOICE_DATE,GL_DEBIT,GL_CREDIT,INVOICE_PAYMENT_AMT FROM Vendor_Reconcilation_System.internal_statement WHERE SUPPLIER_CODE = '${selectedOption}' AND DIVISION_NAME = '${selectedOption1}' AND DOC_CATEGORY LIKE '%BV%' AND status ='Contra';;`,
            
          };
          await fetchDataAndSetTableData(payload, Fetchexecutequery);
          break;
        
        default:
          payload = {};
          await fetchDataAndSetTableData(payload, Fetchbankinvoicedetails);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // const fetchDataAndSetTableData = async (payload, fetchFunction) => {
  //   try {
  //     var FileUploadCredentials = fetchFunction();
  //     const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
  //     setTableData(response.data);
  //   } catch (error) {
  //     console.error('Error in POST request:', error);
  //     throw error;
  //   }

  //   let remarkscol = [];

  //   // Check if tableData has elements
  //   if (tableData.length > 0) {
  //     // Get the keys (column names) of the first object in tableData
  //     const columnNames = Object.keys(tableData[0]);

  //     // Create column definitions based on columnNames
  //     remarkscol = columnNames.map((columnName) => ({
  //       headerName: columnName, // Use column name as header
  //       field: columnName, // Use column name as field
  //     }));
  //   }
  // };

  function generateColumnNames (activeTab){
    let creditColumnName, debitColumnName;
    if (activeTab === 'Annexure1' || activeTab === 'Annexure9' || activeTab === 'Annexure3' || activeTab === 'Annexure4') {
      creditColumnName = 'GL_CREDIT';
      debitColumnName = 'GL_DEBIT';
    } else if (activeTab === 'Annexure5' || activeTab === 'Annexure6' || activeTab === 'Annexure8') {
      creditColumnName = 'credit';
      debitColumnName = 'debit';
    } else if (activeTab === 'Annexure2') {
      creditColumnName = 'debit';
      debitColumnName = 'INVOICE_PAYMENT_AMT';
    } else if (activeTab === 'Annexure7') {
      creditColumnName = 'ven_invoice_amount';
      debitColumnName = 'invoice_amount';
    }
    calculateTotal(creditColumnName,debitColumnName);
    // calculateTotal();
    return { creditColumnName, debitColumnName };
  };

  // Function to calculate totals dynamically based on the active tab and column names
  function calculateTotal(creditColumnName, debitColumnName){
    let totalCredit = 0;
    let totalDebit = 0;
    let totalbal = 0;
    settotalCredit(totalCredit);
    settotalDebit(totalDebit);
    settotalBal(totalbal);
    // const { tableData } = this.state;
    tableData.forEach(row => {
      
      totalCredit += parseFloat(row[creditColumnName]);
      totalDebit += parseFloat(row[debitColumnName]);
      totalCredit = parseFloat(totalCredit.toFixed(2));
      totalDebit = parseFloat(totalDebit.toFixed(2));
      totalbal = totalDebit-totalCredit 
      totalbal = parseFloat(totalbal.toFixed(2));
      settotalCredit(totalCredit);
      settotalDebit(totalDebit);
      settotalBal(totalbal);

    });
    return { totalCredit, totalDebit };
  };
  // let creditColumnName = 'Credit';
  // let debitColumnName = 'debit';

  // const { activeTab, tableData } = this.state;
  // const { creditColumnName, debitColumnName } = generateColumnNames(activeTab);
  // const { totalCredit} = this.calculateTotal(creditColumnName);
  // const { totalDebit } = this.calculateTotal(debitColumnName);



  function getKpiinfo(event) {
    let payload = {
      "table" : selectedOption,
      'accpacid' : selectedOption1,
      'month' : inputMonth,
    };
  
    console.log('payload status', payload,selectedOption);
  
    var getProcessingLayerDataWithStatus = getkpidatarecon();
  
    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(response => {
        console.log("Processing Layer Data With Status with chart data----!!!", response);
        let data = response["data"];
        let arrays = data["Overdue"];
        let arrays1 = data["outstanding_value"];
        let arrays2 = data["total"];
        let annexure1 = data["annexure1total"];
        let annexure2 = data["annexure2total"];
        let annexure3 = data["annexure3total"];
        let annexure4 = data["annexure4total"];
        let annexure5 = data["annexure5total"];
        let annexure6 = data["annexure6total"];
        let annexure7 = data["annexure7total"];
        let annexure8 = data["annexure8total"];
        let annexure9 = data["annexure9total"];
        let intopen = data["intopen"];
        let venopen = data["venopen"];
        let openvariance = data["openvariance"];
        let totalvariance = data["totalvariance"];
        let closingperiod = data["closingperiod"];
  
        // Assuming closingperiod is an array of objects
        let reconperiod = closingperiod.CLOSING_PERIOD[closingperiod.CLOSING_PERIOD.length - 1];
  
        console.log('closingperiod', closingperiod);
  
        let overdue = arrays[0].closing_balance;
        let outsatnding = arrays1[0].closing_balance;
  
        let annexure1total = annexure1 ? parseFloat(annexure1.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure2total = annexure2 ? parseFloat(annexure2.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure3total = annexure3 ? parseFloat(annexure3.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure4total = annexure4 ? parseFloat(annexure4.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure5total = annexure5 ? parseFloat(annexure5.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure6total = annexure6 ? parseFloat(annexure6.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure7total = annexure7 ? parseFloat(annexure7.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure8total = annexure8 ? parseFloat(annexure8.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure9total = annexure9 ? parseFloat(annexure9.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let intopentotal = intopen ? parseFloat(intopen.opening_balance).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let venopentotal = venopen ? parseFloat(venopen.opening_balance).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let openvariancetotal = openvariance ? parseFloat(openvariance).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let variancetotal = totalvariance ? parseFloat(totalvariance.difference).toFixed(2) : "0";
        let check = arrays2 - variancetotal;
        variancetotal = totalvariance ? parseFloat(totalvariance.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        console.log('check', check);
        
        setErpBalance(parseFloat(outsatnding).toFixed(2));
        setVendorBalance(parseFloat(overdue).toFixed(2));
        setVariance(parseFloat(arrays2).toFixed(2));
        setannexure1Balance(annexure1total);
        setannexure2Balance(annexure2total);
        setannexure3Balance(annexure3total);
        setannexure4Balance(annexure4total);
        setannexure5Balance(annexure5total);
        setannexure6Balance(annexure6total);
        setannexure7Balance(annexure7total);
        setannexure8Balance(annexure8total);
        setannexure9Balance(annexure9total);
        setIntopen(intopentotal);
        setVenopen(venopentotal);
        setOpenVariance(openvariancetotal);
        settotalVariance(variancetotal);
        setCheck(parseFloat(check).toFixed(2));
  
        setReconperiod(reconperiod);
  
      })
      .catch(error => {
        console.log("Error in Processing Layer Data WIth Status!!!", error);
      });
  }
  


  const fetchDataAndSetsummaryData = async (tab,payload, fetchFunction) => {
    try {
        var FileUploadCredentials = fetchFunction();
        console.log('tab',tab)

        const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
        const tableData = response.data;
        
        // Generate column definitions
        let remarkscol = [];
        let columnDefs = [];

        // Check if tableData has elements
        if (tableData.length > 0) {
            // Get the keys (column names) of the first object in tableData
            const columnNames = Object.keys(tableData[0]);

            // Create column definitions based on columnNames
        //     remarkscol = columnNames.map((columnName) => ({
        //         headerName: columnName, // Use column name as header
        //         field: columnName, // Use column name as field
        //     }));
        // }

        columnDefs = columnNames.map((columnName) => ({
          headerName: columnName, // Use column name as header
          field: columnName, // Use column name as field
          sortable: true, // Enable sorting for all columns
          filter: true, // Enable filtering for all columns
      }));
  }


        return tableData;
    } catch (error) {
        console.error('Error in POST request:', error);
        throw error;
    }
};

  const fetchDataAndSetTableData = async (payload, fetchFunction) => {
    try {
        var FileUploadCredentials = fetchFunction();
        const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
        const tableData = response.data;
        
        // Generate column definitions
        let remarkscol = [];
        let columnDefs = [];

        // Check if tableData has elements
        if (tableData.length > 0) {
            // Get the keys (column names) of the first object in tableData
            const columnNames = Object.keys(tableData[0]);

            // Create column definitions based on columnNames
        //     remarkscol = columnNames.map((columnName) => ({
        //         headerName: columnName, // Use column name as header
        //         field: columnName, // Use column name as field
        //     }));
        // }

        columnDefs = columnNames.map((columnName) => ({
          headerName: columnName, // Use column name as header
          field: columnName, // Use column name as field
          sortable: true, // Enable sorting for all columns
          filter: true, // Enable filtering for all columns
      }));
  }
        setTableData(tableData);
        setremarkscol(columnDefs);
        return tableData;
    } catch (error) {
        console.error('Error in POST request:', error);
        throw error;
    }
};


  const handleTabChange = (e, { name }) => {
    setActiveTab(name);
    generateColumnNames(activeTab);
  };
  useEffect(() => {
    if (activeTab) {
      generateColumnNames(activeTab);
      // if (activeTab === 'Summary') {
      //   getKpiinfo(activeTab);
      //   // fetchDataForAllTabs()
      // } else {
      //   fetchDataForTab(activeTab);
      // }
    }
  });

  

  return (
    <div className="custom-layout">
      <div style={{ paddingLeft: '20px' }}>
        <Grid>
          <Grid.Row>
            <Grid.Column style={{ width: '15%' }}>
              <div className="form-groups">
                <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Bank Name</label> <br />
                <Select
                  options={options}
                  isClearable
                  onChange={handleSelection}
                  value={options.find(opt => opt.value === selectedOption)}
                  styles={{ container: (provided) => ({ ...provided, width: '100%' }) }}
                />
              </div>
            </Grid.Column>

            <Grid.Column style={{ width: '15%' }}>
              <div className="file-upload-card">
                <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Month</label> <br />
                        <Input type="month" className="cardName filetype" style={{ paddingLeft: "10px",paddingTop: "20px" }} onChange={(e) => { setInputMonth(e.target.value) }} id="file-upload-month" />
                   
                </div>
            </Grid.Column>
            <Grid.Column style={{ width: '20%'}}>
              <br></br>
              <div style={{ marginTop: '25px' }}>
                <Button primary style={{ padding: '8px 12px', fontSize: '14px' }} onClick={handleSearchClick}>
                  Search
                </Button>
              </div>
            </Grid.Column>
            <Grid.Column style={{ width: '20%',paddingTop:  '5px' }}>
            <div>
            <br></br>
            
           {showicon === 'True' && (
  <a href={link}>
    <img
      src={excelIcon}
      alt="No Images"
      style={{ width: '40px', height: '37px' }}
      className="excel-icon-class"
      title="Export"
    />
  </a>
)}

                    </div>
            
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>

      {showTabs && (
        <div className="content-container" style={{ paddingLeft: '10px' }}>
          
          <Grid columns={2} stackable>
  <Grid.Column width={3}>
    <Menu pointing vertical fluid>
      {tabNames.map((tabName) => (
        <Menu.Item
          key={tabName}
          name={tabName}
          active={activeTab === tabName}
          onClick={handleTabChange}
        >
          {tabName === 'Summary' ? 'Summary' : tabName.charAt(0).toUpperCase() + tabName.slice(1)}
        </Menu.Item>
      ))}
    </Menu>
  </Grid.Column>
  <Grid.Column width={13}>
  <Grid.Row>
    
  </Grid.Row>
  <Grid.Row>
    <div className="ag-theme-balham report-layer" style={{ overflow: 'hidden', width: '95%'}}>
      {activeTab === 'Summary' ? (
        <div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
  {summaryItems.map((item, index) => (
    <div key={index} style={{ borderBottom: '1px solid #ddd', padding: '12px', display: 'flex' }}>
      <div style={{ flex: '65%', textAlign: 'left',width: '50px', marginRight: '10px' }}>{item.description}</div>
      <div style={{  marginRight: '10px' }}>:</div>
      <div style={{ flex: '2', textAlign: 'center' }}>{item.value}</div>
    </div>
  ))}
</div>


        </div>
      ) : (

        <div>
        {/* Display multiple totals above the grid table */}
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          <div style={{ paddingRight: '10px', fontWeight: 'bold', fontSize: '1.2em' }}>Debit:</div>
          <div style={{ paddingRight: '40px', fontWeight: 'bold', fontSize: '1.2em' }}>{totaldebits}</div>

          <div style={{ paddingRight: '10px', fontWeight: 'bold', fontSize: '1.2em' }}> Credit:</div>
          <div style={{ paddingRight: '40px',fontWeight: 'bold', fontSize: '1.2em' }}>{totalcredits}</div>

          <div style={{ paddingRight: '10px', fontWeight: 'bold', fontSize: '1.2em' }}> Total:</div>
          <div style={{ fontWeight: 'bold', fontSize: '1.2em' }}>{totalbalan}</div>
        </div>
        
        <div className="ag-theme-alpine"
            style={{ width: '100%' }}
          >
        
         <AgGridReact
        animateRows={true}
        rowData={tableData}
        columnDefs={remarkscol.map(column => ({ ...column, width: 150, resizable: true  }))}
        rowHeight={30}
        pagination={true}
        paginationPageSize={10}
        groupSelectsChildren={true}
        enableFilter={true}
        enableSorting={true}
        enableServerSideSorting={true}
        enableServerSideFilter={true}
        suppressRowClickSelection={true}
        suppressAggAtRootLevel={true}
        domLayout='autoHeight'
      >
         </AgGridReact>
      </div>
      </div>
      )}
      
      
    </div>
    </Grid.Row>
  </Grid.Column>
</Grid>

        </div>
      )}
    </div>
  );
};

export default VerticalTabsWithAgGrid;



